import axios from 'axios'

// initial state
const state = () => ({
  user: null
})

// getters
const getters = {
  user: state => {
    return state.user
  }
}

// actions
const actions = {
  postRegistration({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${'/register/'}`, data).then(response => {
        commit('SET_USER', response.data)
        return resolve(response)
      }).catch(error => reject(error))
    })
  },
  logout({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${'/logout/'}`).then(response => {
        commit('SET_USER', null)
        return resolve(response)
      }).catch(error => reject(error))
    })
  },
}

// mutations
const mutations = {
  SET_USER: (state, data) => {
    state.user = data
    localStorage.setItem('user', JSON.stringify(data))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}